var prepareProps = function prepareProps(compProps, allProps) {
  var componentKeys = Object.keys(compProps);
  var newProps = Object.keys(allProps).reduce(function (object, key) {
    // eslint-disable-next-line no-param-reassign
    if (!componentKeys.includes(key)) object[key] = allProps[key];
    return object;
  }, {});
  return newProps;
};
export default prepareProps;